import React from 'react';

function TimeScopeStep({
  formData,
  errors,
  yearOptions,
  onTimeScopeChange,
  onBudgetChange,
}) {
  return (
    <div className="space-y-6 fade-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">時間範圍</h2>
      </div>

      {/* 年份 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          年份
        </label>
        <select
          value={formData.time_scope.year}
          onChange={(e) => onTimeScopeChange('year', parseInt(e.target.value))}
          className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 ${
            errors.year ? 'border-red-500' : 'border-gray-300'
          }`}
        >
          {yearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        {errors.year && (
          <p className="mt-1 text-sm text-red-600">{errors.year}</p>
        )}
      </div>

      {/* 季度（僅限季度專案） */}
      {formData.project_type === 'quarterly' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            季度
          </label>
          <div className="grid grid-cols-4 gap-3">
            {[1, 2, 3, 4].map((q) => (
              <button
                key={q}
                type="button"
                onClick={() => onTimeScopeChange('quarter', q)}
                className={`px-4 py-3 rounded-lg border-2 font-medium transition-all ${
                  formData.time_scope.quarter === q
                    ? 'border-purple-600 bg-purple-50 text-purple-700'
                    : 'border-gray-300 hover:border-purple-400'
                }`}
              >
                Q{q}
              </button>
            ))}
          </div>
          {errors.quarter && (
            <p className="mt-1 text-sm text-red-600">{errors.quarter}</p>
          )}
        </div>
      )}

      {/* 半年（僅限半年度專案） */}
      {formData.project_type === 'semi-annual' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            半年
          </label>
          <div className="grid grid-cols-2 gap-3">
            {[1, 2].map((h) => (
              <button
                key={h}
                type="button"
                onClick={() => onTimeScopeChange('half', h)}
                className={`px-4 py-3 rounded-lg border-2 font-medium transition-all ${
                  formData.time_scope.half === h
                    ? 'border-purple-600 bg-purple-50 text-purple-700'
                    : 'border-gray-300 hover:border-purple-400'
                }`}
              >
                {h === 1 ? '上半年 (H1)' : '下半年 (H2)'}
              </button>
            ))}
          </div>
          {errors.half && (
            <p className="mt-1 text-sm text-red-600">{errors.half}</p>
          )}
        </div>
      )}

      {/* 自訂日期範圍（臨時專案和活動專案） */}
      {(formData.project_type === 'ad-hoc' || formData.project_type === 'campaign') && (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              開始日期
            </label>
            <input
              type="date"
              value={formData.time_scope.start_date}
              onChange={(e) => onTimeScopeChange('start_date', e.target.value)}
              className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                errors.start_date ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.start_date && (
              <p className="mt-1 text-sm text-red-600">{errors.start_date}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              結束日期
            </label>
            <input
              type="date"
              value={formData.time_scope.end_date}
              onChange={(e) => onTimeScopeChange('end_date', e.target.value)}
              className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                errors.end_date ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.end_date && (
              <p className="mt-1 text-sm text-red-600">{errors.end_date}</p>
            )}
          </div>
        </div>
      )}

      {/* 預算 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          預算（選填）
        </label>
        <div className="flex gap-3">
          <input
            type="number"
            value={formData.budget.total}
            onChange={(e) => onBudgetChange('total', parseFloat(e.target.value) || 0)}
            className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="0"
          />
          <select
            value={formData.budget.currency}
            onChange={(e) => onBudgetChange('currency', e.target.value)}
            className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            <option value="TWD">TWD</option>
            <option value="USD">USD</option>
            <option value="CNY">CNY</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default TimeScopeStep;
